import { useState, useRef, type ReactNode } from "react";
import { cn } from "../lib/utils";

interface HoverCardProps {
  trigger: ReactNode;
  children: ReactNode;
  align?: "left" | "center" | "right";
  side?: "top" | "bottom";
  openDelay?: number;
  closeDelay?: number;
  className?: string;
}

export function HoverCard({
  trigger,
  children,
  align = "center",
  side = "bottom",
  openDelay = 200,
  closeDelay = 150,
  className,
}: HoverCardProps) {
  const [open, setOpen] = useState(false);
  const openTimer = useRef<ReturnType<typeof setTimeout>>();
  const closeTimer = useRef<ReturnType<typeof setTimeout>>();

  const handleOpen = () => {
    clearTimeout(closeTimer.current);
    openTimer.current = setTimeout(() => setOpen(true), openDelay);
  };

  const handleClose = () => {
    clearTimeout(openTimer.current);
    closeTimer.current = setTimeout(() => setOpen(false), closeDelay);
  };

  return (
    <div className="hover-card-root" onMouseEnter={handleOpen} onMouseLeave={handleClose}>
      <div className="hover-card-trigger">{trigger}</div>
      {open && (
        <div
          className={cn(
            "hover-card-content",
            `hover-card-${side}`,
            `hover-card-align-${align}`,
            className,
          )}
          onMouseEnter={() => clearTimeout(closeTimer.current)}
          onMouseLeave={handleClose}
        >
          {children}
        </div>
      )}
    </div>
  );
}
